import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function LocationPin(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 17"
  }, props), React.createElement("path", {
    d: "M4.846.209C1.93.925 0 3.503 0 6.512 0 7.174.09 7.8.268 8.374c.179.644.465 1.235.84 1.772.09.144 3.309 4.566 4.74 6.518a.82.82 0 001.323 0c1.43-1.952 4.667-6.392 4.756-6.553a5.93 5.93 0 00.805-1.737A6.42 6.42 0 0013 6.512C13.018 2.357 9.155-.866 4.846.209zm1.663 9.185A2.879 2.879 0 013.63 6.512a2.879 2.879 0 115.758 0 2.879 2.879 0 01-2.88 2.882z"
  }));
}

export { LocationPin };
//# sourceMappingURL=LocationPin.js.map